import { ReduxState } from '~/types/redux';
import assign from 'lodash/assign';
import { Actions, ActionTypes } from '~/types/recommendation';

const recommendation = (state: ReduxState, action: Actions): ReduxState => {
  switch (action.type) {
    case ActionTypes.SET_RECOMMENDATION:
      return assign({}, state, {
        recommendation: {
          ...state.recommendation,
          bundle: action.productRecommendation.bundle,
          recommendedSpeedPlan: action.productRecommendation.recommendedSpeedPlan,
          recommendedVas: action.productRecommendation.recommendedVas,
          alternativeSpeedPlans: action.productRecommendation.alternativeSpeedPlans,
        },
      });
    case ActionTypes.SET_RECOMMENDATION_FLOW:
      return assign({}, state, {
        ngcConfiguration: {
          ...state.ngcConfiguration,
          recommendationFlow: action.recommendationFlow,
        },
      });
    case ActionTypes.SET_RECOMMENDATIONS:
      return assign({}, state, {
        recommendations: action.recommendations,
      });
    case ActionTypes.SET_VAS_RECOMMENDATIONS:
      return assign({}, state, {
        vasRecommendations: action.vasRecommendations,
      });
    case ActionTypes.SET_SELECTED_RECOMMENDATION:
      return assign({}, state, {
        selectedRecommendationId: action.recommendationId,
      });
    case ActionTypes.SET_VIEW_DETAILS_RECOMMENDATION:
      return assign({}, state, {
        viewDetailsRecommendationId: action.recommendationId,
      });
    case ActionTypes.SET_NGC_CONFIGURATION:
      return assign({}, state, {
        ngcConfiguration: action.ngcConfiguration,
      });
    default:
      return state;
  }
};

export default recommendation;
